import { Component, inject, Input } from "@angular/core";
import { DocumentPageCategories } from "@app/commons/types/enums/constants.enums";
import { IDocumentFilter } from "@app/commons/types/interfaces/documents.interface";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-document-filter-modal",
  templateUrl: "./document-filter-modal.component.html",
  styleUrl: "./document-filter-modal.component.scss",
})
export class DocumentFilterModalComponent {
  modal = inject(NgbActiveModal);

  @Input() selectedFilters: IDocumentFilter[] = [];
  @Input() selectedDivision = "";
  @Input() setFilters!: Function;
  defaultFilters: IDocumentFilter[] = [
    {
      type: "multiselect",
      formControlName: "documentType",
      label: "Document Type",
    },
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "ownerName",
      label: "Owner/Individual Name",
    },
    {
      type: "text",
      formControlName: "name",
      label: "File Name",
    },
    {
      type: "multiselect",
      formControlName: "documentType",
      label: "Document Type",
    },
    {
      type: "date",
      formControlName: "dateOfFiling",
      label: "Date of Filing",
    },
    {
      type: "text",
      formControlName: "streetAddress",
      label: "Street Address",
    },
    {
      type: "text",
      formControlName: "city",
      label: "City",
    },
    {
      type: "state",
      formControlName: "state",
      label: "State",
    },
    {
      type: "date",
      formControlName: "receivedByDate",
      label: "Received By Date",
    },
    {
      type: "text",
      formControlName: "filingNumber",
      label: "Filing Number",
    },
  ];
  businessFilters: IDocumentFilter[] = [
    ...this.defaultFilters,
    {
      type: "text",
      formControlName: "businessId",
      label: "Business ID",
    },
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "date",
      formControlName: "expirationDate",
      label: "Expiration Date",
    },
    {
      type: "range",
      formControlName: "expirationDate",
      label: "Expiration Date Range",
    },
    {
      type: "text",
      formControlName: "incorporator",
      label: "Incorporator",
    },
    {
      type: "text",
      formControlName: "comissionNumber",
      label: "Commission #",
    },
  ];
  securitiesFilters: IDocumentFilter[] = [
    ...this.defaultFilters,
    {
      type: "text",
      formControlName: "registrationNumber",
      label: "Registration Number",
    },
    {
      type: "text",
      formControlName: "secRegistrationNumber",
      label: "SEC Registration Number",
    },
  ];
  adsdFilters: IDocumentFilter[] = [
    ...this.defaultFilters,
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "dealerId",
      label: "Dealer ID",
    },
    {
      type: "dealerType",
      formControlName: "dealerType",
      label: "Dealer Type",
    },
    {
      type: "text",
      formControlName: "county",
      label: "County",
    },
    {
      type: "date",
      formControlName: "issueDate",
      label: "Issue Date",
    },
    {
      type: "range",
      formControlName: "issueDate",
      label: "Issue Date Range",
    },
    {
      type: "date",
      formControlName: "expirationDate",
      label: "Expiration Date",
    },
    {
      type: "range",
      formControlName: "expirationDate",
      label: "Expiration Date Range",
    },
  ];

  allOrderedFilters: IDocumentFilter[] = [
    {
      type: "multiselect",
      formControlName: "documentType",
      label: "Document Type",
    },
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "ownerName",
      label: "Owner/Individual Name",
    },
    {
      type: "text",
      formControlName: "name",
      label: "File Name",
    },
    {
      type: "date",
      formControlName: "dateOfFiling",
      label: "Date of Filing",
    },
    {
      type: "range",
      formControlName: "dateOfFiling",
      label: "Date of Filing Range",
    },
    {
      type: "text",
      formControlName: "streetAddress",
      label: "Street Address",
    },
    {
      type: "text",
      formControlName: "city",
      label: "City",
    },
    {
      type: "text",
      formControlName: "county",
      label: "County",
    },
    {
      type: "state",
      formControlName: "state",
      label: "State",
    },
    {
      type: "date",
      formControlName: "receivedByDate",
      label: "Received By Date",
    },
    {
      type: "text",
      formControlName: "filingNumber",
      label: "Filing Number",
    },
    {
      type: "text",
      formControlName: "businessId",
      label: "Business ID",
    },
    {
      type: "text",
      formControlName: "incorporator",
      label: "Incorporator",
    },
    {
      type: "text",
      formControlName: "comissionNumber",
      label: "Commission #",
    },
    {
      type: "text",
      formControlName: "registrationNumber",
      label: "Registration Number",
    },
    {
      type: "text",
      formControlName: "secRegistrationNumber",
      label: "SEC Registration Number",
    },
    {
      type: "text",
      formControlName: "dealerId",
      label: "Dealer ID/Dealer Number",
    },
    {
      type: "dealerType",
      formControlName: "dealerType",
      label: "Dealer Type",
    },
    {
      type: "date",
      formControlName: "issueDate",
      label: "Issue Date",
    },
    {
      type: "range",
      formControlName: "issueDate",
      label: "Issue Date Range",
    },
    {
      type: "date",
      formControlName: "expirationDate",
      label: "Expiration Date",
    },
    {
      type: "range",
      formControlName: "expirationDate",
      label: "Expiration Date Range",
    },
  ];

  toggleFilter(filter: IDocumentFilter) {
    let isRemoved = false;
    if (this.isFilterSelected(filter)) {
      this.selectedFilters = this.selectedFilters.filter(
        (f) => f.label !== filter.label
      );
      isRemoved = true;
    } else {
      this.selectedFilters.push(filter);
    }
    if (this.setFilters) {
      this.setFilters(this.selectedFilters, filter, isRemoved);
    }
  }

  handleKeydown(event: KeyboardEvent, filter: IDocumentFilter) {
    if (event.key === "Enter" || event.key === " ") {
      this.toggleFilter(filter);
      event.preventDefault();
    }
  }

  getIconForFilterType(type: string): string {
    switch (type) {
      case "date":
        return "icons/linear/calendar.svg";
      case "range":
        return "icons/linear/calendar-range.svg";
      case "state":
        return "icons/linear/state.svg";
      case "text":
        return "icons/linear/text.svg";
      default:
        return "icons/linear/text.svg";
    }
  }

  isFilterSelected(filter: IDocumentFilter) {
    return this.selectedFilters.some((obj) =>
      Object.values(obj).includes(filter.label)
    );
  }

  getUniqueValues(array: IDocumentFilter[]): IDocumentFilter[] {
    const uniqueArray = array.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.label === value.label)
    );
    return uniqueArray;
  }

  get allFilters() {
    return this.getUniqueValues(this.allOrderedFilters);
  }

  closeModal() {
    this.modal.close();
  }
}
